import { AutogenModelOrderPayables, AutogenRowOrderPayables } from "./autogen/AutogenModelOrderPayables";

export class ModelOrderPayables extends AutogenModelOrderPayables<RowOrderPayables> {
	constructor() {
		super(RowOrderPayables);
	}
}

export class RowOrderPayables extends AutogenRowOrderPayables {
}